import { render, staticRenderFns } from "./RegionsForm.vue?vue&type=template&id=471c91eb&scoped=true&"
import script from "./RegionsForm.vue?vue&type=script&lang=js&"
export * from "./RegionsForm.vue?vue&type=script&lang=js&"
import style0 from "./RegionsForm.vue?vue&type=style&index=0&id=471c91eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471c91eb",
  null
  
)

export default component.exports